<!-- 
	Badge
	props: User
  	role: User
	Called by @/views/User && @/views/Settings to display a fancy badge of user information
	This component is disabled on Mobile on the settings page
-->

<template>
	<div class="badge">
		<div class="top mx-auto">
			<div class="text">
				<template
					v-if="
						user.apiData.Profile.Current5050TicketPackage !== null ||
							user.apiData.Profile.New5050TicketPackage !== null
					"
				>
					<div
						v-if="
							user.apiData.Profile.Current5050TicketPackage == 35 ||
								user.apiData.Profile.New5050TicketPackage == 35
						"
					>
						<div>
							<span class="amount">Sets of 25</span><br />
							<span class="smaller">50/50 Tickets for</span><br />
							<span>$</span><span class="dollars">35</span>
						</div>
					</div>
					<div
						v-if="
							user.apiData.Profile.Current5050TicketPackage == 25 ||
								user.apiData.Profile.New5050TicketPackage == 25
						"
					>
						<div>
							<span class="amount">Sets of 25</span><br />
							<span class="smaller">50/50 Tickets for</span><br />
							<span>$</span><span class="dollars">25</span>
						</div>
					</div>
					<div
						v-if="
							user.apiData.Profile.Current5050TicketPackage == 10 ||
								user.apiData.Profile.New5050TicketPackage == 10
						"
					>
						<div>
							<span class="amount">Sets of 4</span><br />
							<span class="smaller">50/50 Tickets for</span><br />
							<span>$</span><span class="dollars">10</span>
						</div>
					</div>
					<div
						v-if="
							user.apiData.Profile.Current5050TicketPackage == 5 ||
								user.apiData.Profile.New5050TicketPackage == 5
						"
					>
						<div>
							<span class="amount">Single</span><br />
							<span class="smaller">50/50 Ticket for</span><br />
							<span>$</span><span class="dollars">5</span>
						</div>
					</div>
				</template>
				<div v-else>
					<div>
						<span class="amount">No</span><br />
						<span class="smaller">Quarterly Cash 50/50<br />Ticket Package</span><br />
						<span>Selected</span>
					</div>
				</div>
			</div>
		</div>
		<div class="middle mx-auto">
			<div class="name">
				{{ user.apiData.Profile.FirstName }} {{ user.apiData.Profile.LastName }}
			</div>
			<div class="email">
				{{ user.apiData.Profile.EmailAddress }}
			</div>
		</div>
		<div class="bottom mx-auto">
			<div class="benefitting">
				{{
					user.apiData.Profile.CurrentDesignation ||
						user.apiData.Profile.NewDesignation
				}}
			</div>
			<div class="employeeId">
				Employee ID {{ user.apiData.Profile.EmployeeId }}
			</div>
			<hr />
			<div class="company">
				<span v-if="user.apiData.Profile.PayrollSelection === 'CHR'">
					Alberta Health Services
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'CW'">
					Carewest
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'COV'">
					Covenant Health
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'LAB'">
					Alberta Precision Labs
				</span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "BadgeFifty",
		props: ["user"],
	};
</script>
<style lang="scss" scoped>
	.badge {
		margin: 0 auto;
		text-align: center;
		.top {
			background: url("../assets/badge-package-5050.svg") top center/cover no-repeat;
			width: 295px;
			height: 249px;
			color: #cea685;
			.text {
				padding-top: 6rem;
				font-size: 30px;
				line-height: 1;
				.amount {
					text-transform: uppercase;
					padding-top: 15px;
				}
				.smaller {
					font-size: 15px;
				}
				.dollars {
					font-size: 72px;
					vertical-align: middle;
				}
			}
		}
		.middle {
			background: url("../assets/badge-name-email-5050.svg") top center/cover
				no-repeat;
			width: 295px;
			color: #fafafa;
			padding: 1rem 0;
			.name {
				text-transform: uppercase;
				font-size: 24px;
			}
			.email {
				text-transform: lowercase;
				font-size: 15px;
			}
		}
		.bottom {
			background: url("../assets/badge-facility-id-payroll-5050.svg") top
				center/cover no-repeat;
			color: #cea685;
			width: 295px;
			padding: 1rem 0;
			.benefitting {
				padding: 15px 0 30px;
				font-size: 18px;
			}
			.employeeId {
				padding: 5rem 0 0;
				text-transform: uppercase;
				color: #1a1f56;
			}
			hr {
				width: 60%;
				margin: 5px auto;
				border-color: #b4816d;
			}
			.company {
				text-transform: uppercase;
				color: #1a1f56;
			}
		}
	}
</style>
